import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getPostById } from '../data/blogData';
import ArticlePost from './ArticlePost';
import NewsPost from './NewsPost';

const BlogPost = () => {
  const { id } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    const postData = getPostById(id);
    setPost(postData);
  }, [id]);

  if (!post) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        fontSize: '1.25rem',
        color: '#6c757d'
      }}>
        <p>Loading...</p>
      </div>
    );
  }

  // Route to appropriate component based on post type
  if (post.type === 'news') {
    return <NewsPost />;
  }

  return <ArticlePost />;
};

export default BlogPost;

